<template>
<v-dialog
    v-model="dialog"
    max-width="600"
    v-if="filter_option != null"
>
    <v-card>
        <v-card-title>Filter {{filter_option.column_label}}</v-card-title>

        <v-card-text>
            <m-edit-date
                label="Start Date (inclusive)"
                v-model="current_value.values[0]"
                v-on:input="onSetStopDate($event)"
            />
            <m-edit-date
                label="End Date (inclusive)"
                v-model="current_value.values[1]"
            />
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
            Ok
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>
const _ = require('lodash');
const Time = require('@/js/time.js');

export default {

    data() {
        return {
            dialog: false,
            filter_option: null,
            current_value: null,
        }
    },

    methods: {

        showDialog(filter_option, current_value)
        {
            this.filter_option = _.cloneDeep(filter_option);
            this.current_value = _.cloneDeep(current_value);

            this.createInitialValueDateInRangeInclusive();
            

            this.dialog = true;
        },

        createInitialValueDateInRangeInclusive()
        {
            if ( this.current_value != null || this.filter_option.type != 'date-in-range-inclusive' ) 
                return;

            let start_date = Time.toISOFirstDayOfMonth(new Date());
            let stop_date = Time.toISOLastDayOfMonth(new Date());   

            this.current_value = {
                'type': 'in-range-inclusive',
                'values': [start_date, stop_date],
                ... this.getValueFieldsInheritedFromFilterOption(),
                
            };
        },

        getValueFieldsInheritedFromFilterOption()
        {
            return {
                'transform_values': this.filter_option.transform_values,
                'column_label': this.filter_option.column_label,
                'column_id': this.filter_option.column_id,
            };
        },
        

        onOk()
        {
            this.dialog = false;
            this.$emit('ok', this.current_value);
        },

        onCancel()
        {
            this.dialog = false;
        },

    },
}
</script>

<style lang="scss" scoped>
</style>